import React from 'react';

const OverviewStatisticsContent = ({ overviewStats }) => {
  return (
    <div className="Summary_auto_second_header_content summary-stats-content">
      {overviewStats.map((stat) => (
        <section className="Summary_auto_second_header_card" key={stat.label}>
          <div className="Summary_auto_second_header_card_title">{stat.label}</div>
          <div className="Summary_auto_second_header_card_content summary-stat-value">{stat.value}</div>
        </section>
      ))}
    </div>
  );
};

export default OverviewStatisticsContent; 